import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { getResetByTag, rem, typography, colors } from '../../../styles';
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("display:flex;align-self:flex-start;line-height:", typography.typographyLineHeightMi, ";margin:", rem(0, 0, 8, 0), ";svg{path{fill:", colors.navy_500, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var resetStyles = getResetByTag('span');
var StyledSelectablePanelIcon = /*#__PURE__*/_styled('span', process.env.NODE_ENV === "production" ? {
  target: "ecg2bjx0"
} : {
  target: "ecg2bjx0",
  label: "StyledSelectablePanelIcon"
})(resetStyles, defaultStyles);
export default StyledSelectablePanelIcon;